module.exports = __webpack_public_path__ + "static/media/05-gallery3.c59d6596.png";